/**
* 系统管理 用户管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>快递订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="">
        <el-input size="small" v-model="formInline.orderNumber" clearable placeholder="订单编号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userPhone" clearable placeholder="下单电话"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="formInline.orderStatus" clearable placeholder="请选择订单状态">
          <el-option label="待接单" value="待接单"></el-option>
          <el-option label="待完成" value="待完成"></el-option>
          <el-option label="异常" value="异常"></el-option>
          <el-option label="已送达" value="已送达"></el-option>
          <el-option label="已退款" value="已退款"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="formInline.siteName" clearable placeholder="请选择快递驿站">
          <el-option
            v-for="item in postStationList"
            :key="item.siteName"
            :label="item.siteName"
            :value="item.siteName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" @click="orderTaking()">批量接单</el-button>
        <el-button size="small" type="primary" @click="deliveryClick()">批量送达</el-button>

        <!--        <el-button size="small" type="primary"  @click="deliveryPrice()">快递价格调整</el-button>-->
        <!--        <el-button size="small" type="primary"  @click="goUpstairs()">上楼价格调整</el-button>-->

        <!--        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange">
      <!--      <el-table-column align="center" type="selection" width="50">-->
      <!--      </el-table-column>-->
      <el-table-column
        type="selection"
        :selectable="selectableCallback"
        width="55">
      </el-table-column>
      <el-table-column align="center" prop="code" label="取件码" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="userName" label="下单名称" width="120">
      </el-table-column>
      <el-table-column align="center" prop="userPhone" label="下单电话" width="120">
      </el-table-column>
      <el-table-column align="center" prop="blockNumber" label="寝室楼号" width="120">
      </el-table-column>
      <el-table-column align="center" prop="chamberNumber" label="寝室号" width="120">
      </el-table-column>
      <el-table-column align="center" prop="orderNumber" label="订单编号" width="120">
      </el-table-column>
      <!--      <el-table-column align="center" prop="siteName" label="快递驿站" width="150">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column align="center" prop="pickupCode" label="取件码" width="120">-->
      <!--      </el-table-column>-->
      <el-table-column align="center" prop="isUpstairs" label="是否上楼" min-width="150" :formatter="sample">
      </el-table-column>
      <el-table-column align="center" prop="createdAt" label="创建时间" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="orderStatus" label="订单状态" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="amount" label="金额(元)" min-width="120">
      </el-table-column>
      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="text" v-if="scope.row.orderStatus!='待支付'"
                     @click="detailUser(scope.$index, scope.row)">查看详情
          </el-button>
          <el-button size="mini" type="text" v-if="scope.row.orderStatus=='待接单'||scope.row.orderStatus=='异常'"
                     @click="deleteUser(scope.$index, scope.row)">退款
          </el-button>
          <el-button size="mini" type="text" v-if="scope.row.orderStatus=='待接单'"
                     @click="takingClick(scope.$index, scope.row)">接单
          </el-button>
          <el-button size="mini" type="text" v-if="scope.row.orderStatus=='待完成'"
                     @click="abnormalClick(scope.$index, scope.row)">异常
          </el-button>
          <el-button size="mini" type="text" v-if="scope.row.orderStatus=='待完成'"
                     @click="deliveryClick2(scope.$index, scope.row)">送达
          </el-button>


        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="用户昵称" prop="name">
          <el-input size="small" v-model="editForm.name" clearable auto-complete="off" maxlength="20"
                    placeholder="请输入用户名"></el-input>
        </el-form-item>
        <!--        <el-form-item label="证件号" prop="cardId">-->
        <!--          <el-input size="small" v-model="editForm.cardId" type="number" maxlength="18"  clearable  placeholder="请输证件号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="手机号" prop="mobile">
          <el-input size="small" v-model="editForm.mobile" clearable maxlength="11" auto-complete="off"
                    placeholder="请输手机号"></el-input>
        </el-form-item>
        <el-form-item label="用户地区" prop="city">
          <el-input size="small" v-model="editForm.city" clearable auto-complete="off"
                    placeholder="请输入用户地区"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            v-model="editForm.birthday"
            size="small"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择出生日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="editForm.gender">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改快递价格" :visible.sync="deliveryPriceVisible" width="30%"
               @click='closeDialog("expressEdit")'>
      <el-form label-width="140px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="修改快递价格" prop="express">
          <el-input size="small" v-model="editForm.express" maxlength="2" type="number" auto-complete="off"
                    placeholder="请输入快递价格"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("expressEdit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitChartered('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
// 导入请求方法
import {
  selectAllOrdering,
  updateWechat,
  delectWeChat,
  selectAllSite,
  takingOrders,
  batchDelivery,
  abnormal, abnormals
} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '修改用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      deliveryPriceVisible: false,
      // 编辑与添加
      editForm: {
        userId: '',
        name: '',
        cardId: '',
        mobile: '',
        gender: '',
        city: '',
        birthday: '',
        express: '',
      },

      // rules表单验证
      rules: {
        name: [
          {required: true, message: '请输入用户名', trigger: 'blur'}

        ],
        city: [
          {required: true, message: '请输入用户地区', trigger: 'blur'},
          {
            validator: function (rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }

        ],
        birthday: [
          {required: true, message: '请输入选择出生日期', trigger: 'blur'}
        ],
        cardId: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
          {
            pattern: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/,
            required: true,
            message: '请输入正确的身份证号',
            trigger: 'blur'
          }
        ],

        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],

        gender: [{required: true, message: '请选择性别', trigger: 'blur'}]
      },

      // 请求数据参数
      formInline: {
        limit: 1,
        page: 10,
        userPhone: '',
        siteName: '',
        orderStatus: '',
        orderNumber: '',

      },
      formInline2: {
        limit: 1,
        page: 100,
        name: '',

      },
      //用户数据
      userData: [],
      list1: [],
      list2: [],
      //选择快递驿站
      postStationList: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.getStationDate(this.formInline2);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    selectableCallback(row, index) {
      // 返回false表示禁止选择当前行
      if (row.orderStatus == '待接单' || row.orderStatus == '待完成') {
        return true;

      } else {
        return false;

      }
    },
    takingClick: function (index, row) {
      this.list1 = [
        row.id,
      ]
      takingOrders(this.list1).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: '已接单！'
          })
          this.getdata(this.formInline);
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    orderTaking() {
      if (this.list1 == '' || this.list1 == null) {
        this.$message({
          type: 'none',
          message: '请选择订单！'
        })
        return
      }
      if (this.list1.length <= 1) {
        this.$message({
          type: 'none',
          message: '请选择多个订单！'
        })
        return
      }
      takingOrders(this.list1).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: '已接单！'
          })
          this.getdata(this.formInline);
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    deliveryClick() {
      if (this.list2 == '' || this.list2 == null) {
        this.$message({
          type: 'none',
          message: '请选择订单！'
        })
        return
      }
      batchDelivery(this.list2).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: '已送达！'
          })
          this.getdata(this.formInline);
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    deliveryClick2: function (index, row) {
      this.list2 = [
        row.id,
      ]
      batchDelivery(this.list2).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: '已送达！'
          })
          this.getdata(this.formInline);
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },

    deliveryPrice() {
      this.deliveryPriceVisible = true;
    },
    goUpstairs() {

    },
    handleSelectionChange(val) {
      let multipleSelection = val;
      multipleSelection.forEach(item => {
        if (item.orderStatus == '待取件') {
          this.list1.push(item.id);
        } else {
          this.list2.push(item.id);

        }
      });
      console.log('this.list1----', this.list1)
    },
    sample(row, column, cellValue) {
      if (cellValue == true) {
        return '是'
      } else if (cellValue == false) {
        return '否'
      } else {
        return '是'
      }
    },
    getStationDate(parameter) {
      selectAllSite(parameter).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.postStationList = res.data.list;

        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      console.log('parameter', parameter);
      selectAllOrdering(parameter).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.userData = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.limit;
          this.pageparm.pageSize = this.formInline.page;
          this.pageparm.total = res.data.totalRow;
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.pageSize
      this.formInline.limit = parm.currentPage
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      console.log('row----', row)
      if (row != undefined && row != 'undefined') {
        this.editForm.userId = row.id
        this.editForm.name = row.name
        if (row.identityInformation != null) {
          this.editForm.cardId = row.identityInformation.idCardNumber
        } else {
          this.editForm.cardId = ''
        }
        this.editForm.mobile = row.mobile
        this.editForm.gender = row.gender
        this.editForm.birthday = row.birthday
        this.editForm.city = row.city

      }
    },
    abnormalClick: function (index, row) {
      abnormals(row.id)
        .then(res => {
          console.log('res----', res);

          this.deliveryPriceVisible = false
          this.loading = false
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
            this.getdata(this.formInline)

          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          console.log('this.editForm', this.editForm);
          updateWechat(this.editForm)
            .then(res => {
              console.log('res----', res);

              this.editFormVisible = false
              this.loading = false
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.getdata(this.formInline)

              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    submitChartered(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          console.log('this.editForm', this.editForm);
          abnormal(this.editForm)
            .then(res => {
              console.log('res----', res);

              this.deliveryPriceVisible = false
              this.loading = false
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                // this.getdata(this.formInline)

              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },


    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },


    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'expressEdit') {
        this.deliveryPriceVisible = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 退款
    deleteUser(index, row) {
      this.$confirm('确定要退款吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delectWeChat(row.orderId)
            .then(res => {
              console.log('res----', res)
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '已退款!'
                })
                if (this.pageparm.total <= 11) {
                  this.formInline.limit = 1;
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
    },

    // 详情
    detailUser(index, row) {
      setTimeout(() => {
        this.logining = false
        this.$router.push({path: 'orderDetail/detail', query: row})
      }, 1000)
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/deliveryOrder.vue